//import { App } from 'vue';

// Plugin para detectar móvil en vertical
export default {
  install(app) {
    app.config.globalProperties.$isMobile = () => {
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isPortraitOrientation = window.innerHeight > window.innerWidth;
      return isMobileDevice && isPortraitOrientation;
    };
  },
};
